import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../Confirmation'

import { QA_NAME_DOCUMENT_MARK_AS_INVOICE_CONFIRM_MODAL } from './DocumentMarkAsInvoiceConfirmModal.constants'

function DocumentMarkAsInvoiceConfirmModal({ onClose, onSubmit }) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('DocumentMarkAsInvoice.ConfirmBtnKey'),
      }}
      description={t('DocumentMarkAsInvoice.ConfirmDescriptionKey')}
      qaName={QA_NAME_DOCUMENT_MARK_AS_INVOICE_CONFIRM_MODAL}
      title={t('Common.AttentionModalTitleKey')}
      onCancel={onClose}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default DocumentMarkAsInvoiceConfirmModal
